import { render, staticRenderFns } from "./HostedPageCommunication.vue?vue&type=template&id=ec602d32&"
import script from "./HostedPageCommunication.vue?vue&type=script&lang=js&"
export * from "./HostedPageCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports